export const styles = {
  cardResumo: {
    minHeight: 120,
    width: '100%',
  },
  cardPeriodo: {
    minHeight: 120,
    width: '100%',
  },
  cardProduto: {
    maxHeight: 120,
    width: 'auto',
  },
  paperGrafico: {
    width: '100%',
    minHeight: 250,
    padding: 16,
    overflow: 'hidden',
  },
  paperGraficoGrande: {
    width: '100%',
    minHeight: 300,
    padding: 16,
    overflow: 'hidden',
    backgroundColor: '#fff8ee',
  },
  boxTitulo: {
    borderBottom: '1px solid #000',
    paddingBottom: '8px',
    marginBottom: '16px',
  },
  topLogo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
    marginBottom: 16,
  },
  topLogoInline: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 120,
    width: '100%',
  },
  topCardsScroller: {
    width: '100%',
    paddingBottom: 8,
  },
  topCardsGrid: {
    marginTop: 0,
  },
  topCardsGridWide: {
    marginTop: 0,
  },
  chartArea: {
    width: '100%',
    height: 220,
  },
  chartAreaLarge: {
    width: '100%',
    height: 320,
  },
  charts: {
    width: '100%',
    minHeight: 300,
    padding: 16,
    overflow: 'hidden',
    backgroundColor: '#fff8ee',
  },
  chartSub: {
    width: 658,
    height: 230,
    padding: 16,
    overflow: 'hidden',
    backgroundColor: '#fff8ee',
  },
};
